<template>
  <div class="row">
    <div class="col-12">
      <div class="subpage">
        <h1 class="subpage__headline">Kontakt</h1>
        <div class="subpage__content">
          Jeśli masz jakieś pytania o akcję Adoptuj Pszczołę lub chcesz się z
          nami skontaktować, zapraszamy! Nasze biuro pracuje od wtorku do piątku
          w godz. 10:00-15:00.<br />
          <br />
          Fundacja Greenpeace Polska<br />
          ul. Altowa 4<br />
          02-386 Warszawa<br />
          <br />
          Telefon: 22 659 84 99<br />
          Email: spl@greenpeace.org
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
  title() {
    return `Kontakt`;
  },
  pageType: "Kontaktowa",
  data() {
    return {
      title: "Contact page",
    };
  },
  mounted() {
    setTimeout(this.scrollToTop(), 1200);
  },
  methods: {
    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
      });
    },
  },
};
</script>
